import React from 'react';
import { useHistory } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {Box, Grid} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import {API_URL} from '../utils/EnvVars';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import NotificationAlerts from "../components/NotificationAlerts";
import ReportsListView from "../components/ReportsListView";
import '../styles/bizofficer-a.css';
import TutorialButton from '../components/StudentTutorial/StudentTutorial';
import Cookies from "js-cookie";
import NewTutorialButton from '../components/StudentTutorial/NewStudentTutorial';
import { useDispatch, useSelector } from 'react-redux';
import {setPopup } from "../store/popup.actions";

///import 'font-awesome/css/font-awesome.min.css';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	},
	  padding: theme.spacing(1),
	},
}));  
  
const columns = [
	{ field: 'id', headerName: '#', width: 40 },
	{ field: 'mockTestName', headerName: 'Title', 
	renderHeader: () => (
		<span style={{lineHeight:1}}>
		  Title<br/><span style={{fontSize:9}}>Click to view details</span>
		</span>
	  ), width: 300, renderCell: (params) =>  (
			<div>
				<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>		
			</div>
	   ), },
	   { field: 'testType', headerName: 'Type', width: 135 },
	{ field: 'submitDateTime', headerName: 'Date', width: 125 },
	{ field: 'totalQuestions', headerName: 'Total Questions', width: 165 },
	{ field: 'fullMarks', headerName: 'Full Marks', width: 135 },
	{ field: 'marksObtain', headerName: 'Marks Obtain', width: 150 },
	{ field: 'timeSpent', headerName: 'Time Spent', width: 145 }
];

  const columnLS = [
	  { field: 'id', headerName: '#', width: 40 },
	  { field: 'mockTestName', headerName: 'Title', 
	renderHeader: () => (
		<span style={{lineHeight:1}}>
		  Title<br/><span style={{fontSize:9}}>Click to view details</span>
		</span>
	  ), width: 300, renderCell: (params) =>  (
		  <div>
				<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>		
			</div>
	   ), },
	   { field: 'testType', headerName: 'Type', width: 125 },
	   { field: 'submitDateTime', headerName: 'Date', width: 125 },
	   { field: 'totalQuestions', headerName: 'Total Questions', width: 170 },
	   { field: 'helpCounter', headerName: 'Help in Questions', width: 175 },
	{ field: 'correctQuestions', headerName: 'Correct', width: 121 },
	{ field: 'incorrectQuestions', headerName: 'Incorrect', width: 125 },
	{ field: 'unattemptedQuestions', headerName: 'Unattempted', width: 150 }
  ];



  
  export default function Execute() {
	const classes = useStyles();
	//const dispatch = useDispatch();
	let history = useHistory();
	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		history.push('login');
	}
	const popup1 = useSelector((state => state?.popup1))
   const ftue = Cookies.get("ftue");
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
	const [rows, setRows] = React.useState([]);
	const [dataRows, setDataRows] = React.useState([]);
	const [pageLoading, setPageLoading] = React.useState(true);
	const [selectTab, setSelectTab] = React.useState(1);

	const authResult = new URLSearchParams(window.location.search);
    const deviceType = authResult.get('device_type');
    if(deviceType && deviceType.length>0){
      localStorage.setItem("deviceType", deviceType);
    }


	React.useEffect(() => {		
		if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].selfTest===1){
			setSelectTab(1);
		}else if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].mockTest===1){
			setSelectTab(4);
		}else if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].topicTest===1){
			setSelectTab(3);
		}else if(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].classTest===1 && etlStudentObj.schools && etlStudentObj.schools[0] && etlStudentObj.schools[0].schoolId>0){
			setSelectTab(5);
		}else{
			setSelectTab(1);
		}
		getApiData();			
	}, [selectedCourse]);

	async function getApiData(){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			//+'&studentId='+etlStudentObj.studentId
			setPageLoading(true);
			axios.get(API_URL+'/reportanalytics?panel=student&courseId='+mySelectedCourses[selectedCourse].courseId, axiosHeader)
			   .then(response => {
				setPageLoading(false);
				///document.write(JSON.stringify(response.data));
			 	///console.log("Just Checking >> "+response.data);  
				 if(response.data && response.data.responseTxt==='success'){
					if(response.data.obj && response.data.obj?.length>0){
						setRows(response.data.obj);	
						setDataRows(response.data.obj);					
					}
			   	}else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.removeItem('etlStudentObj');  
					window.localStorage.clear();
					history.push('logout');
				
			   	}				 				 				
			})
	}

	function goToDetail(obj){
		if(obj && rows[obj.id-1]){
			if(rows[obj.id-1].examType==='subjective'){
				if(rows[obj.id-1].testTypeId==3){
					history.push("testviewsubjective?testId=mt"+rows[obj.id-1].testSession);
				}else{
					history.push("testviewsubjective?testId=st"+rows[obj.id-1].testSession);
				}	
			}else if(rows[obj.id-1].testTypeId==3 || rows[obj.id-1].testTypeId==5){
				history.push("analytics?testId="+rows[obj.id-1].testSession);
			}else if(rows[obj.id-1].testTypeId==1 && rows[obj.id-1].testType=='Learning Session'){
				history.push("learning-testanalytics?testId="+rows[obj.id-1].testSession);
			}else if(rows[obj.id-1].testTypeId==7 && rows[obj.id-1].testType && rows[obj.id-1].testType.indexOf('Learning')>-1){
				history.push("learning-testanalytics?testId="+rows[obj.id-1].testSession);		
			}else{
				history.push("testanalytics?testId="+rows[obj.id-1].testSession);
			}	
		}
	}

	React.useEffect(() => {		
		if(dataRows && dataRows.length>0){
			filterRows(selectTab);
		}			
	}, [dataRows,selectTab]);

	const handleChangeTab = (event, newValue) => {		
		setSelectTab(newValue);	
	};

	const filterRows = (tabVal) => {
		if(dataRows){
			let filterRows = [];
			let j = 1;		
			for(let i=0; i<dataRows.length; i++){
				if(tabVal===1 && dataRows[i].testType && dataRows[i].testType.indexOf('Learning')>-1){
					dataRows[i].id=j;					
					filterRows.push(dataRows[i]);
					j++;
				}else if(tabVal===2 && dataRows[i].testType==='Competitive Session'){
					dataRows[i].id=j;
					filterRows.push(dataRows[i]);
					j++;
				}else if(tabVal===3 && dataRows[i].testType==='Topic Test'){
					dataRows[i].id=j;
					filterRows.push(dataRows[i]);
					j++;
				}else if(tabVal===4 && dataRows[i].testType==='Mock Test'){
					dataRows[i].id=j;
					filterRows.push(dataRows[i]);
					j++;
				}else if(tabVal===5 && dataRows[i].testType==='Class Test'){
					dataRows[i].id=j;
					filterRows.push(dataRows[i]);
					j++;
				}
			}
			setRows(filterRows);
		}
	};

	return (
		<div> 
				<MetaTags>
            		<title>Report & Analytics</title>
          		</MetaTags>
				
			  	<Header />	
				<LeftDrawer />
				<main className={classes.content}>
				<NotificationAlerts />
				{pageLoading?<LinearProgress />:null}
				<Box style={window.screen.width>480?{marginBottom:100, marginLeft:20, marginRight:20}:{}}>	
					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<h3 className="heading" >Report & Analytics</h3>
								</Grid>
							</Grid>
					</Box>
					<Box sx={{ width: '100%', bgcolor: 'background.paper' }}>

					{window.screen.width>480?
						<Tabs 
						value={selectTab}
						onChange={handleChangeTab}
						centered
						>
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].selfTest===1)?
								<Tab label="Learning Session" value={1} style={{textTransform:'none'}} />
							:null}
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].selfTest===1)?
								<Tab label="Competitive Session" value={2} style={{textTransform:'none'}} />
							:null}
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].topicTest===1)?
								<Tab label="Topic Test" value={3} style={{textTransform:'none'}} />
							:null}
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].mockTest===1)?
								<Tab label="Mock Test" value={4} style={{textTransform:'none'}} />
							:null}
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].classTest===1 && etlStudentObj.schools && etlStudentObj.schools[0] && etlStudentObj.schools[0].schoolId>0)?
								<Tab label="Class Test" value={5} style={{textTransform:'none'}} />
							:null}						
						</Tabs>
					:
						<Tabs 
						value={selectTab}
						onChange={handleChangeTab}
						centered
						variant={"scrollable"}
						scrollButtons={"on"}
						>
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].selfTest===1)?
								<Tab label="Learning" value={1} style={{textTransform:'none',marginRight:-10}} />
							:null}
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].selfTest===1)?
								<Tab label="Competitive" value={2} style={{textTransform:'none',marginRight:-10}} />
							:null}
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].topicTest===1)?
								<Tab label="Topic Test" value={3} style={{textTransform:'none',marginRight:-10}} />
							:null}
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].mockTest===1)?
								<Tab label="Mock Test" value={4} style={{textTransform:'none',marginRight:-10}} />
							:null}
							{(mySelectedCourses && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].classTest===1 && etlStudentObj.schools && etlStudentObj.schools[0] && etlStudentObj.schools[0].schoolId>0)?
								<Tab label="Class Test" value={5} style={{textTransform:'none'}} />
							:null}						
						</Tabs>
  					}	
					</Box>


					{window.screen.width>480?						
						<div className="tblReport" style={{height: '70vh', width: '100%' }}>
							<DataGrid
								rows={rows}
								columns={selectTab>1?columns:columnLS}
								pageSize={100}
								rowHeight={40}
								rowsPerPageOptions={[100]}
								ActionsComponent={()=>{alert('Hello')}}		
								style={{fontSize:12}}	
								onRowClick={itm => goToDetail(itm)}			
							/>
						</div>
					:<ReportsListView rows={rows} selectTab={selectTab} goToDetail={goToDetail} />
					}	

				</Box>
				  {/* Tutorial Button to get demo  */}
				<TutorialButton/>
				</main>

				{ popup1  ? <NewTutorialButton /> : <></>}

		</div>	
	);
  }